import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { Modal } from '../../../components';
import { SU } from '../../../constants/ConfigConst';
import BotonNuevoComponent from '../../entidades/components/BotonNuevo';
import {
  checkModuleAccess,
  isManagerUserCode,
} from '../../modulos/modules.helpers';
import {
  getAllServiciosAction,
  setActivoServiciosAction,
} from './ServiciosAction';
import FormServicios from './components/FormServicios';
import ListadoServicios from './components/ListadoServicios';

const ServiciosView = () => {
  const dispatch = Redux.useDispatch();

  const serviciosStore = Redux.useSelector((state) => state.servicios);
  const entidadesStore = Redux.useSelector((state) => state.entidades);

  const [openModalForm, setOpenModalForm] = React.useState(false);
  const loginStore = Redux.useSelector((state) => state.login);

  const isRoot = loginStore.user.roles.some((r) => r.name === SU);
  const isManager =
    !isRoot &&
    isManagerUserCode(loginStore.user.userCodes, entidadesStore.activo?.id);

  const accessName = 'classes';
  if (!checkModuleAccess(accessName, loginStore)) {
    window.location.href = '/dashboard';
  }

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {!isManager && (
          <BotonNuevoComponent
            click={async () => {
              await setActivoServiciosAction(dispatch, null);
              setOpenModalForm(true);
            }}
            azul
            mr={2}
          />
        )}
        <BotonNuevoComponent
          click={async () => {
            await setActivoServiciosAction(dispatch, null);
            await getAllServiciosAction(dispatch, serviciosStore.params);
          }}
          white
          disabled={serviciosStore.loadingGetAll}
          text={serviciosStore.loadingGetAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoServicios setOpenModalForm={(val) => setOpenModalForm(val)} />
      </Grid>
      <Modal
        id="modalFormServicios"
        title={`${serviciosStore.activo ? 'Editar' : 'Nueva'} servicio`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        {serviciosStore.activo && (
          <Typography variant="h6">
            {serviciosStore.activo.nombres} {serviciosStore.activo.apellidos}
          </Typography>
        )}
        <FormServicios
          activo={serviciosStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Modal>
    </Grid>
  );
};

export default ServiciosView;
